module.exports = __webpack_public_path__ + "img/camel-comb2-3.b472cc50.jpg";